<script>
export default {
  props: {
    item: {
      default: {}
    }
  }
};
</script>

<template>
  <div>
    <b-form>
      <b-form-group
        id="input-group-1"
        label="Nome"
        label-for="nome"
        v-model="item"
      >
        <b-form-input
          id="nome"
          v-model="item.nome"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="E-mail" label-for="email">
        <b-form-input
          id="email"
          v-model="item.email"
          type="email"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="Telefone" label-for="telefone">
        <b-form-input
          id="telefone"
          v-model="item.telefone"
          v-mask="'(##)#####-####'"
          placeholder="(00)00000-0000"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1 " class="mt-4">
        <b-form-checkbox
          v-model="item.possuiUsuario"
          name="check-button"
          switch
        >
          Cadastrar usuário?
        </b-form-checkbox>
      </b-form-group>
    </b-form>
  </div>
</template>
